import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import "./userDetailsTable.css";
import { FaPencilAlt } from "react-icons/fa";

const UserDetailsTable = ({ userdetails, selectedcompany,getuserdetails }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [modify, setmodify] = useState({
    newname: "",
    newcontact: "",
    newemail: "",
    newpassword: "",
  });

  const handlemodify = async () => {
    if (
      modify.newname &&
      modify.newcontact &&
      modify.newemail &&
      modify.newpassword
    ) {
      alert("Please fill anyone of the fields");
      return;
    }
    {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyuser.php`;
      const formData = new FormData();

      formData.append("id", selectedUser.id);
      formData.append("user_name", modify?.newname || selectedUser.user_name);
      formData.append("email", modify?.newemail || selectedUser.email);
      formData.append("phone_no", modify?.newcontact || selectedUser.phone_no);
      formData.append("password", modify?.newpassword || selectedUser.password);

      const response = fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setmodify({
            newname: "",
            newemail: "",
            newcontact: "",
            newpassword: "",
          });
          setSelectedUser(null);
          alert(data.message);
          getuserdetails();

        })
        .catch((error) => {
          console.log("Error with POST request:", error);
        });
    }
  };

  return (
    <div className="admin-portal-user-details-wrapper">
      <div className="admin-portal-user-table">
        <p className="company-info">
        Client Name:&nbsp;<strong>{selectedcompany}</strong> 
        </p>

        {/* <h3>User Details</h3> */}
        {Array.isArray(userdetails) && userdetails.length > 0 ? (
          <table className="user-table">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Name</th>
                {/* <th>Email</th> */}
                {/* <th>Contact</th>  */}
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userdetails.map((item, index) => (
                <tr key={item.id || index} className="user-row">
                  <td>{index + 1}</td>
                  <td>{item.user_name}</td>
                  <td>{item.role}</td>
                  <td>
                    <button
                      onClick={() => {
                        setSelectedUser({
                          user_name: item.user_name,
                          email: item.email,
                          phone_no: item.phone_no,
                          role: item.role,
                          id: item.id,
                          password: item.password,
                        });
                        setIsEditingName(false);
                        setIsEditingEmail(false);
                        setIsEditingContact(false);
                        setIsEditingPassword(false);
                      }}
                      className="sebtn"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No users available.</p>
        )}
      </div>

      {/* Side Popup Panel */}
      <AnimatePresence>
        {selectedUser && (
          <motion.div
            initial={{ x: "150%" }}
            animate={{ x: 0 }}
            exit={{ x: "150%" }}
            transition={{ type: "spring", stiffness: 80 }}
            className="user-detail-popup"
          >
            <button
              className="close-popup"
              onClick={() => setSelectedUser(null)}
            >
              &times;
            </button>
            <h4 className="userh4">User Info</h4>

            <div className="user-info-section">
              {/* Role */}
              <p>
                <strong>Role:</strong> {selectedUser.role}{" "}
              </p>

              {/* Name */}
              {!isEditingName ? (
                <p>
                  <strong>Name:</strong> {selectedUser.user_name}
                  <button onClick={() => setIsEditingName(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Name:</strong>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    value={modify?.newname}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newname: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingName(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Email */}
              {!isEditingEmail ? (
                <p>
                  <strong>Email:</strong> {selectedUser.email}{" "}
                  <button onClick={() => setIsEditingEmail(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Email:</strong>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter email"
                    value={modify?.newemail}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newemail: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingEmail(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Contact */}
              {!isEditingContact ? (
                <p>
                  <strong>Contact:</strong> {selectedUser.phone_no}{" "}
                  <button onClick={() => setIsEditingContact(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Contact:</strong>
                  </label>
                  <input
                    type="tel"
                    pattern="[0-9]{10}"
                    placeholder="Enter contact number"
                    value={modify?.newcontact}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newcontact: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingContact(false)}>
                    &times;
                  </button>
                </div>
              )}

              {/* Password */}
              {!isEditingPassword ? (
                <p>
                  <strong>Password:</strong> *********{" "}
                  <button onClick={() => setIsEditingPassword(true)}>
                    <FaPencilAlt />
                  </button>
                </p>
              ) : (
                <div className="input-block">
                  <label>
                    <strong>Contact:</strong>
                  </label>
                  <input
                    type="tel"
                    pattern="[0-9]{10}"
                    placeholder="Enter Password"
                    value={modify?.newpassword}
                    onChange={(e) =>
                      setmodify((prev) => ({
                        ...prev,
                        newpassword: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => setIsEditingPassword(false)}>
                    &times;
                  </button>
                </div>
              )}
            </div>
            <div className="sbtn1">
              <p>
                <button className="sbtn" onClick={handlemodify}>
                  Submit
                </button>
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UserDetailsTable;












